<template>
  <modal
    ref="fileExplorer"
    title="Prehliadač úložiska"
    name="file-explorer"
    scrollable
    full-height
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="okAction"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <div class="tree-view">
              <tree-view :items="items" @select="treeSelectedItem" />
            </div>
          </div>
        </div>
      </transition>
    </b-overlay>
    <template #modal-footer="{ ok, cancel }">
      <div class="fs-sm">
        <strong>{{ actionTitle }}: </strong>
        <template v-if="sourceItems.length > 1">
          {{ sourceItems.length }} položky
        </template>
        <template v-else>
          <img
            v-if="sourceItems[0].typeID == 1"
            width="15"
            src="/images/folder.png"
          />
          <img
            v-else
            width="15"
            :src="`/images/${sourceItems[0].extension}.png`"
          />
          {{ sourceItems[0].name }}
        </template>
      </div>
      <b-button @click="cancel()"> Zrušiť </b-button>
      <b-button :disabled="actionReady" variant="primary" @click="ok()">
        {{ actionTitle }}
      </b-button>
    </template>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import TreeView from './TreeView'

export default {
  components: {
    Modal,
    TreeView,
  },
  props: {
    url: {
      type: Object,
      required: true,
    },
    actionTitle: {
      type: String,
      default: 'OK',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      sourceItems: [],
      activeItem: {},
    }
  },
  computed: {
    actionReady() {
      if (
        !this.loading &&
        Object.keys(this.activeItem).length &&
        this.sourceItems.length
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$api.get(this.url.list).then((res) => {
        this.items = [
          {
            id: 0,
            name: 'Hlavný priečinok',
            parent_it: null,
            children: res.data,
          },
        ]
        this.loading = false
      })
    },
    okAction(e) {
      e.preventDefault()
      let selectedIds = this.sourceItems.map((i) => i.id)
      this.$api
        .post(this.url.action, {
          source: selectedIds,
          target: this.activeItem.id,
        })
        .then(() => {
          this.$root.$emit('modal-hide', 'file-explorer')
          this.$root.$emit('filemanager/reloadList')
        })
    },
    treeSelectedItem(item) {
      this.activeItem = item
    },
  },
}
</script>
